import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as S from 'App.styles';
import { Footer, Header } from 'view/organisms';
import { PageRoot } from 'view/pages/PageRoot';
import 'i18n/i18n';
import { NotificationCountFetcher } from 'utils/NotificationCountFetcher';
import { AlertHandler } from 'utils/AlertHandler';
import { usePageViewTracking } from 'hooks';

const PageViewTracker = () => {
  usePageViewTracking();
  return null;
};

export const App = () => {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <S.AppStyled>
        <Header />

        <S.ContentStyled>
          <PageRoot />
        </S.ContentStyled>

        <Footer />
      </S.AppStyled>

      <AlertHandler />
      <NotificationCountFetcher />
    </BrowserRouter>
  );
};
